var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockRestart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89999 0.619102C5.89949 0.619102 2.64509 3.8249 2.54789 7.8155V8H0.413086L3.64769 11.5046L6.79229 8H4.38749V7.8155C4.48379 4.8428 6.91469 2.465 9.89999 2.465C12.9474 2.465 15.4179 4.9436 15.4179 8C15.4179 11.0564 12.9474 13.535 9.89999 13.535C8.72501 13.5357 7.58083 13.1593 6.63569 12.4613L5.37029 13.8149C6.6618 14.83 8.25731 15.3809 9.89999 15.3791C13.9635 15.3791 17.2566 12.0761 17.2566 8C17.2566 3.9239 13.9635 0.619102 9.89999 0.619102ZM8.99999 3.5V8C9.00101 8.23848 9.09572 8.46701 9.26369 8.6363L12.1437 11.5163C12.3984 11.3516 12.6387 11.1662 12.852 10.9511L10.8 8.9V3.5H8.99999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRestart);
export default __webpack_public_path__ + "static/media/clock-restart.b384eaed.svg";
export { ForwardRef as ReactComponent };